import { render } from "./FPluginTimeline.vue?vue&type=template&id=2853b20e&scoped=true"
import script from "./FPluginTimeline.vue?vue&type=script&lang=js"
export * from "./FPluginTimeline.vue?vue&type=script&lang=js"

import "./FPluginTimeline.vue?vue&type=style&index=0&id=2853b20e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2853b20e"]])

export default __exports__